import React, { FC } from 'react';

import { DocumentListItem } from '@/components/elements/document-list-item';
import { StyledDocumentContainer } from '@/components/elements/document-list-item/styled';

import { useTranslate } from '@/shared/hooks/use-translate';
import { Heading } from '@/shared/ui/heading';
import { Layout } from '@/shared/ui/layout';

type TProps = {
    docs: DocumentOrder[];
};

export const DocumentPage: FC<TProps> = ({ docs }) => {
    const { t } = useTranslate();

    return (
        <Layout.Content>
            <Heading as="h1" marginB="42" marginBMobile="16">
                {t('Документы')}
            </Heading>
            <StyledDocumentContainer>
                {docs.map((doc, index) => (
                    <DocumentListItem key={index} {...doc} />
                ))}
            </StyledDocumentContainer>
        </Layout.Content>
    );
};
